import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ProgressBar from "react-bootstrap/ProgressBar";
import "./PersonReviewedObjective.css";

function PersonReviewedObjective({
  id,
  description,
  grade,
  weight,
  lastCheckInProgress,
}) {
  const { t } = useTranslation();

  return (
    <Col key={id} className="person-reviewed-objective">
      <Row className="justify-content-center align-items-center">
        <Col lg={8}>
          <p className="person-reviewed-objective-description">{description}</p>
        </Col>
        <Col lg={3} className="right">
          <ProgressBar
            now={lastCheckInProgress}
            label={`${lastCheckInProgress}%`}
          />
        </Col>
        <Col lg={1} className="right">
          <h6 className="person-reviewed-objective-weight">{weight}</h6>
        </Col>
      </Row>
      <Row>{}</Row>
    </Col>
  );
}

export default PersonReviewedObjective;
